import { Component, EventEmitter, Input, Output } from '@angular/core';
import { map } from 'rxjs';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'hazmatsuite-next-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent {
  @Output() uploadFiles = new EventEmitter<FileList>();
  @Input() dropZoneVisible = true;
  @Input() multiple = true;
  @Input() required = false;
  @Input() label = '';

  smartPackageTanslation$ = this.languageService.translations$.pipe(
    map(data => data['SmartPackageResource'])
  );

  constructor(private languageService: LanguageService) {
    this.languageService.fetchResources(['SmartPackageResource']);
  }

  onFileDropped(event: FileList): void {
    this.uploadFiles.next(event);
  }

  fileBrowseHandler(data: any) {
    this.uploadFiles.next(data.files as FileList);
  }
}
